export const socketKeys = {
  toClient: {
    userInitialized: 'userInitialized',
    user: {
      exists: 'userExists',
      existingGame: 'existingGame',
      existingJoin: 'existingJoin',
      updated: 'updatedUser'
    },
    game: {
      started: 'gameStarted',
      roundEvent: 'gameRoundEvent',
      alreadyStarted: 'gameAlreadyStarted',
      startDisconnectTimer: 'startDisconnectTimer',
      newRound: 'newRound',
      ended: 'gameEnded',
      reset: 'gameReset',
      playerFacing: 'playerFacing',
      playerEmote: 'playerEmote'
    },
    room: {
      created: 'roomCreated',
      userJoined: 'userJoinedRoom',
      userDisconnected: 'userDisconnected',
      userLeft: 'userLeftRoom',
      disbanded: 'roomDisbanded',
      requiresPassword: 'requiresPassword'
    },
    player: 'player',
    error: 'error',
    eventLog: 'eventLog'
  },
  toServer: {
    initialConnect: 'initialConnect',
    user: {
      update: "updateUser"
    },
    game: {
      start: 'startGame',
      roundEvent: 'roundEvent',
      disconnectTimerEnded: 'disconnectTimerEnded',
      turnTimerEnded: 'turnTimerEnded',
      updateFacing: 'updateFacing',
      sendEmote: 'sendEmote'
    },
    room: {
      create: 'createRoom',
      join: 'joinRoom',
      rejoin: 'rejoinRoom',
      leave: 'leaveRoom',
      disband: 'disbandRoom',
      addBot: 'addBot',
      kick: 'kick'
    },
    disconnect: 'disconnect',
  }
}